import * as React from "react";

const { FormattedNumber } = require("react-intl");

interface MoneyProps {
  value: string | number;
  decimals?: boolean;
  label?: string;
  placeholder?: string;
}

class Money extends React.Component<MoneyProps, any> {
  public static defaultProps = {
    decimals: true, // Note: instead of keeping decimals as a bool, could be cleaner to use decimalPlaces?
    value: "",
  };

  formattedNumber() {
    const value = this.props.value || "";
    let decimalPlaces = this.props.decimals ? 2 : 0;

    // if value is 0, do not show decimals
    if (Number(value) === 0) {
      decimalPlaces = 0;
    }

    return (
      <FormattedNumber
        value={value}
        style="currency"
        currency="USD"
        minimumFractionDigits={decimalPlaces}
        maximumFractionDigits={decimalPlaces}
      />
    );
  }

  render() {
    const { label } = this.props;
    if (label) {
      return (
        <span>
          {label}
          &nbsp;
          {this.formattedNumber()}
        </span>
      );
    }
    return this.formattedNumber();
  }
}

export default Money;
